export default "__VITE_ASSET__CkdkabRP__"